import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["displayYear", "displayDay", "timezone", "children", "useExactEventTimes", "eventDisplay"];
import { useMemo } from 'react';
import DayCalendarView from './DayCalendarView';
import { getSortedChildren, distributeEventsToHours
// @ts-expect-error no types
} from '../../lib/eventParse';
import { getMomentForDay } from '../../lib/time';
import { getEventsToDisplay } from '../../lib/eventDisplay';
import { ONE_DAY_IN_MILLISECONDS } from '../../constants/time';
import { jsx as _jsx } from "react/jsx-runtime";
const getDayEventRange = ({
  displayYear,
  displayDay,
  timezone
}) => {
  const start = getMomentForDay(displayYear, displayDay, timezone).startOf('day').valueOf();
  const end = start + ONE_DAY_IN_MILLISECONDS - 1;
  return {
    start,
    end
  };
};
const DayCalendarWrapper = _ref => {
  let {
      displayYear,
      displayDay = 1,
      timezone,
      children,
      useExactEventTimes,
      eventDisplay
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const sortedChildren = useMemo(() => getSortedChildren(children, useExactEventTimes, timezone), [children, timezone, useExactEventTimes]);
  const eventsToDisplay = useMemo(() => {
    return getEventsToDisplay({
      sortedChildren,
      eventDisplay,
      eventRange: getDayEventRange({
        displayYear,
        displayDay,
        timezone
      })
    });
  }, [sortedChildren, eventDisplay, displayYear, displayDay, timezone]);
  const distributedEvents = useMemo(() => distributeEventsToHours(eventsToDisplay.events, timezone), [eventsToDisplay.events, timezone]);
  return /*#__PURE__*/_jsx(DayCalendarView, Object.assign({}, props, {
    eventDisplay: eventDisplay,
    displayYear: displayYear,
    displayDay: displayDay,
    allDayEvents: eventsToDisplay.allDayEvents,
    useExactEventTimes: useExactEventTimes,
    timezone: timezone,
    events: distributedEvents
  }));
};
export default DayCalendarWrapper;